module.exports = __webpack_public_path__ + "static/apple-icon-152x152-2dbd574d3133b71cdb1398157f0b6293.png";